import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebEntityComponent } from './web-entity.component';
import { MaterialModuleWeb } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    WebEntityComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleWeb
  ],
  exports:[
    WebEntityComponent
  ]
})
export class WebEntityModule { }
